import { render, staticRenderFns } from "./DestinationReport.vue?vue&type=template&id=b97d775a&scoped=true&"
import script from "./DestinationReport.vue?vue&type=script&lang=js&"
export * from "./DestinationReport.vue?vue&type=script&lang=js&"
import style0 from "./DestinationReport.vue?vue&type=style&index=0&id=b97d775a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97d775a",
  null
  
)

component.options.__file = "DestinationReport.vue"
export default component.exports